import React, { useEffect, useRef } from 'react';
import Typography from 'Components/Atoms/Typography';
import './styles.scss';

export type AuthNoticeBannerProps = {
  tone?: 'error' | 'info';
  title?: string;
  // Already translated message.
  message: string;
  // Move the focus here when shown, e.g. after a sign-in was refused.
  focus?: boolean;
  children?: React.ReactNode;
};

const AuthNoticeBanner = ({ tone = 'error', title, message, focus = false, children }: AuthNoticeBannerProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focus) ref.current?.focus();
  }, [focus, message]);

  return (
    <div
      ref={ref}
      className={`auth-notice-banner tone-${tone}`}
      role={tone === 'error' ? 'alert' : 'status'}
      tabIndex={-1}
    >
      {title && (
        <Typography variant="text-2" weight="bold" block translation={null}>
          {title}
        </Typography>
      )}
      <Typography variant="text-3" block translation={null}>
        {message}
      </Typography>
      {children && <div className="auth-notice-actions">{children}</div>}
    </div>
  );
};

export default AuthNoticeBanner;
